<template>
  <div id="help">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left" @click="toHref()">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        <img src="@/assets/logo.png" width="21" height="25" style="margin-top:6px" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>
      </div>
      <div class="right" @click="toHref()" >
        <van-icon name="wap-home" size="21"/>
      </div>
    </div>
    <div class="main padding">
      <van-swipe :autoplay="4000" indicator-color="#80BE61">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img src="@/assets/banner1.png" style="width:100%" />
        </van-swipe-item>
      </van-swipe>
      <div class="want-tit">
        <span class="yuan1"></span>
        <span class="yuan2 yuan3"></span>
        我想帮
        <span class="yuan1 yuan4"></span>
        <span class="yuan2"></span>
      </div>
      <div class="want-list">
        <div class="wants border-right" @click="toMenu(1)">
          <img src="@/assets/help1.png" />
          <span>提供岗位</span>
        </div>
        <div class="wants"  @click="toMenu(2)">
          <img src="@/assets/help2.png"/>
          <span>志愿服务</span>
        </div>
      </div>
      <div class="want-list want-list3">
        <div class="wants wants3 border-right" @click="toMenu(3)">
          <img src="@/assets/help3.png" />
          <span>爱心捐赠</span>
        </div>
        <!-- <div class="wants" @click="toMenu(4)">
          <img src="@/assets/help4.png" />
          <span>时间银行</span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Swipe, SwipeItem } from "vant";
export default {
  components: {
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data() {
    return {
      images: ["@/assets/banner1.png", "@/assets/banner1.png"]
    };
  },
  methods: {
    toUrl(u) {
      this.$router.push(u);
    },
      // 跳转首页
    toHref(){
      window.location.href="http://ncymkj.doudou00.com/index.php?g=Wap&m=Index&a=lists&token=hmatos1596436588&classid=20403"
    },
    toMenu(t){
       this.$router.push({
        path: "/helpMenu",
        query: {
          type:t,
        },
      });
    }
  }
};
</script>
<style scoped>
#help {
  height: 100%;
  color: black;
  /* background-color: #F3F9F6; */
}
.want-tit {
  height: 3rem;
  line-height: 3rem;
}
.yuan1,
.yuan2 {
  width: 1rem;
  height: 1rem;
  background: #9edb62;
  display: inline-block;
  border-radius: 1rem;
  top: 0.1rem;
  position: relative;
}
.yuan2 {
  background: #ecad3e;
}
.yuan3 {
  right: 0.5rem;
}
.yuan4 {
  left: 0.5rem;
}
.main {
  height: 100%;
  background: #f3f9f6;
}
.want-list {
  display: flex;
  padding: 1rem 0;
  background: white;
    border-bottom: solid 1rem #f3f9f6;
}
.want-list3{
  width: 50%;
}
.wants {
  /* display: flex; */
  width: 50%;
  /* text-align: center; */
  text-align: left;
  margin-left: 10%;
}
.wants3{
  width: 100%;
  /* text-align: center; */
  margin-left: 20%;
}
.wants img {
  width: 1.8rem;
  display: inline-block;
  vertical-align: middle;
}
.border-right {
  border-right: solid 2px #aaaaaa;
}
</style>


// WEBPACK FOOTER //
// src/page/help.vue